// import { AmplifyS3Image } from "@aws-amplify/ui-react";

import Grid, { GridProps } from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { Storage } from 'aws-amplify'
import React, { useEffect, useState } from 'react'

import Entitlement from './Entitlement'
import ImageDialog from './ImageDialog'
import { Entitlement as EntitlementApi } from '../API'

interface RetrievedPresignedUrl {
  key: string
  presignedUrl: string
}

interface PresignedUrl {
  [key: string]: string
}

type Entitlement = Omit<Exclude<EntitlementApi, null>, '__typename'>

interface Props extends GridProps {
  entitlements?: Entitlement[]
}

const getS3PresignedUrl = (key: string) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const presignedUrl = await Storage.get(key)
      resolve({ key, presignedUrl })
    } catch (e) {
      console.log(e)
      reject()
    }
  })
}

const EventDetailsEntitlements: React.FC<Props> = ({ entitlements }) => {
  const theme = useTheme()
  const [selectedEntitlement, setSelectedEntitlement] =
    useState<Entitlement | null>()
  const [open, setOpen] = useState(false)

  const [presignedUrls, setPresignedUrls] = useState<PresignedUrl>({})
  useEffect(() => {
    const fetch = async () => {
      if (entitlements instanceof Array) {
        const results = await Promise.all(
          entitlements
            ?.filter((entitlement) => entitlement?.photo?.thumbnailKey)
            .map((entitlement) =>
              getS3PresignedUrl(entitlement?.photo?.thumbnailKey || ''),
            ),
        )

        const imageUrls: PresignedUrl = {}
        results.forEach((result: RetrievedPresignedUrl) => {
          imageUrls[result.key] = result.presignedUrl
        })
        setPresignedUrls(imageUrls)

        return
      }
    }
    if (entitlements) fetch()
  }, [entitlements])

  return (
    <Grid container spacing={2}>
      {/* Entitlements */}
      <Grid container justifyContent="center" alignItems="center" size={12}>
        <Typography variant="h5" sx={{ marginTop: theme.spacing(6) }}>
          Inclusions
        </Typography>
      </Grid>
      {entitlements && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          size={12}>
          {entitlements instanceof Array &&
            entitlements
              .sort((a: Entitlement, b: Entitlement) => {
                if (!!a.priority && !b.priority) return -1
                if (!!b.priority && !a.priority) return 1
                return a.priority - b.priority
              })
              .map((entitlement: Entitlement) => (
                <Grid
                  key={`entitlement${entitlement.name}`}
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="center"
                  sx={(theme) => ({
                    marginBottom: theme.spacing(4),
                  })}
                  onClick={() => {
                    if (
                      entitlement?.photo?.thumbnailKey &&
                      entitlement.photo.thumbnailKey in presignedUrls
                    ) {
                      setSelectedEntitlement(entitlement)
                      setOpen(true)
                    }
                  }}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                  }}>
                  <Grid size={12}>
                    <Entitlement
                      image={
                        entitlement?.photo?.thumbnailKey &&
                        entitlement.photo.thumbnailKey in presignedUrls
                          ? `${presignedUrls[entitlement.photo.thumbnailKey]}`
                          : `${process.env.PUBLIC_URL}/images/megatechph_icon.png`
                      }
                      name={entitlement.name}
                    />
                  </Grid>
                </Grid>
              ))}

          <ImageDialog
            open={open}
            title={selectedEntitlement?.name || ''}
            onDialogClose={() => {
              setOpen(false)
            }}
            onButtonClose={() => {
              setOpen(false)
            }}
            image={
              selectedEntitlement?.photo?.key &&
              selectedEntitlement.photo.key in presignedUrls
                ? `${presignedUrls[selectedEntitlement.photo.key]}`
                : `${process.env.PUBLIC_URL}/images/megatechph_icon.png}`
            }
          />
        </Grid>
      )}
    </Grid>
  )
}
export default EventDetailsEntitlements
